define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml"
], function(declare,New,xml) {

	return declare(New, {
		_canNavigate: function() {
			// summary: restrict Save&Go here
			return false;
		},

		_onAction: function() {
			// summary: create RoutingItem or SubRoutingItem to wrap new SubRouting, pointing to its current revision
			this.validateNode(this.m_urlNode, true);
			var	typeNode = this.widget.relRoot.getTargetClass().getType();
			var urlItem = this.m_urlNode;
			var urlItemRev = xml.getUrlPath(urlItem, "Child:CurrentRevision");

			this.m_urlNode = this.createNewUrl();

			this.m_cnNew = this.m_writer.createNode(this.m_urlNode, typeNode)
				.changeAttribute("Actual", xml.ATTR_REF, urlItemRev)
				.changeAttribute("Original", xml.ATTR_REF, urlItemRev);
		}
	});
});